import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import ok from 'assets/img/icon/ok.png';
import Activity from 'components/Activity';
import config from 'data/config.json';

import BigIcon from 'UI/atoms/BigIcon';
import CardContent from 'UI/atoms/CardContent';
import Title from 'UI/atoms/Title';
import TextBox from 'UI/atoms/TextBox';
import Link from 'UI/atoms/Link';
import Subtitle from 'UI/atoms/Subtitle';
import { useParams, useLocation, useNavigate } from 'react-router-dom';

const RegisterCompleted = () => {
  const { t, i18n } = useTranslation();
  const { locale } = useParams();
  const [userData, setUserData] = useState(null);
  const [activityData, setActivityData] = useState(null);
  const [activityId, setActivityId] = useState(null);
  const { state } = useLocation();
  const navigate = useNavigate();

  const zone = config.zones.find((zone) => zone.locale === i18n.language);

  useEffect(() => {
    if (!state) {
      navigate(`/${locale}`);
      return;
    }
    const { data, activityId } = state;
    setUserData(data[0]);
    if (data.length === 2) {
      setActivityData(data[1]);
    }
    if (activityId) {
      setActivityId(activityId);
    }
  }, [state]);

  if (!userData) {
    return <></>;
  }

  return (
    <>
      <CardContent sm={{ span: 10, offset: 1 }}>
        <BigIcon src={ok} />
        <Title>{t('register_validation.title')}</Title>
        {activityData &&
          <Subtitle>{t('register_validation.activity_subtitle')}</Subtitle>
        }
        {!activityData &&
          <Subtitle>{t('register_validation.no_activity_subtitle')}</Subtitle>
        }
      </CardContent>
      {!activityData &&
        <CardContent sm={{ span: 10, offset: 1 }}>
          {!userData.hasCompany &&
            <TextBox color="yellow">
              <p>{t('register_validation.add_company_text')}</p>
              <Link href={t('register_validation.add_company_href')} arrow="right">
                <strong>{t('register_validation.add_company_link')}</strong>
              </Link>
            </TextBox>
          }
          {zone.downloadAvailable &&
            <TextBox color="blue">
              <p>{t('register_validation.download_text')}</p>
              <Link arrow="down" href={t('register_validation.download_href')}>
                <strong>{t('register_validation.download_link')}</strong>
              </Link>
            </TextBox>
          }
        </CardContent>
      }
      {activityData &&
        <CardContent color="light-gray" sm={{ span: 10, offset: 1 }}>
          <Activity data={activityData} token={userData.token} activityId={activityId} />
        </CardContent>
      }
      <CardContent color="gray" type="no-padding" sm={{ span: 12 }}>
        <TextBox>
          <p>{t('register_validation.footer_text')}</p>
          <Link href={t('web.domain')} target="_blank" arrow="right">
            {t('register_validation.footer_link_text')}
          </Link>
        </TextBox>
      </CardContent>
    </>
  );
};

export default RegisterCompleted;
